import { useTranslation } from "react-i18next";

import { TableHeadCell } from "@digital-services/ui";
import type { SortQueryDirection } from "@ds-cps/ui";

import { AuditLogModelKeys } from "@audit-log/models";

interface Props {
  handleSortHeaderClick: (val: string) => void;
  activeSort?: string;
  sortDirection?: SortQueryDirection;
}

export const AuditLogHeader = (props: Props) => {
  const { activeSort, sortDirection, handleSortHeaderClick } = props;

  const { t: tAuditLog } = useTranslation(undefined, {
    keyPrefix: "audit-log"
  });

  function renderBasicTableHeadCell(columnName: AuditLogModelKeys) {
    return (
      <TableHeadCell data-testid={`audit-log-table-column-${columnName}`}>
        <span>{tAuditLog(`table.headers.${columnName}`)}</span>
      </TableHeadCell>
    );
  }

  function renderSortableTableHeadCell(columnName: AuditLogModelKeys) {
    return (
      <TableHeadCell
        sortActive={activeSort === columnName}
        sortDirection={sortDirection}
        onSort={() => handleSortHeaderClick(columnName)}
        data-testid={`audit-log-table-column-${columnName}`}
      >
        <span>{tAuditLog(`table.headers.${columnName}`)}</span>
      </TableHeadCell>
    );
  }

  // order per User Story
  const eventTimestamp = "timestamp";
  const eventId = "id";
  const user = "userEmail"; // value for column "User"
  const organization = "organization";
  const resource = "resource";
  const application = "application";
  const changedBy = "userContextEmail"; // value for column "Changed by"
  const requestSource = "sourceApplicationName"; // value for column "Request source"
  const eventType = "action"; // value for column "Event type"

  return (
    <tr className="leading-[0px]">
      {renderSortableTableHeadCell(eventTimestamp)}
      {renderBasicTableHeadCell(eventId)}
      {renderBasicTableHeadCell(user)}
      {renderBasicTableHeadCell(organization)}
      {renderBasicTableHeadCell(resource)}
      {renderBasicTableHeadCell(application)}
      {renderBasicTableHeadCell(changedBy)}
      {renderBasicTableHeadCell(requestSource)}
      {renderBasicTableHeadCell(eventType)}
    </tr>
  );
};
